export const UPDATE_LOADING = "UPDATE_LOADING";
export const UPDATE_MESSAGE = "UPDATE_MESSAGE";

export const UPDATE_TOKEN = "UPDATE_TOKEN";
export const UPDATE_USER_DATA = "UPDATE_USER_DATA";

export const UPDATE_TERMS = "UPDATE_TERMS";

export const UPDATE_PLANS = "UPDATE_PLANS";

export const UPDATE_STORE_TYPES = "UPDATE_STORE_TYPES";
